import { useState } from 'react';
import { AnimateLoading } from '../../../../components/common/loading/AnimateLoading';
import { PopupConfirmModal } from '../../../../components/common/modal/popup/PopupConfirmModal';
import { useGetMyOwnTractors } from '../../../../hooks/api/user/queries/useGetMyOwnTractors';
import { UserOwnProductDetailCardWrapper } from '../../../../views/Product/listView/UserOwnProductDetailCard/UserOwnProductListDetailCardGroup';
import { ListContainer } from './ListContainer';
import { MyInfoUserOwnProductCard } from './MyInfoUserOwnProductCard';
import { IMyOwnTractor } from '../../../../interfaces/OwnTractor.interfaces';
import { usePatchMyOwnTractorsMutation } from '../../../../hooks/api/user/mutations/usePatchMyOwnTractors.mutation';

export const UnpublishedTractorListSection = ({ changeTabIndex }: { changeTabIndex: (index: number) => void }) => {
  const [selectedTractor, setSelectedTractor] = useState<IMyOwnTractor>();
  const [isPokeRequestModalOpen, setIsPokeRequestModalOpen] = useState(false);

  const PUBLISHED_TAB = 0;

  const { mutate: patchUsersOwnTractor } = usePatchMyOwnTractorsMutation();
  const {
    data: usersOwnTractors,
    isLoading: isGetUsersOwnTractorsLoading,
    refetch: refetchUsersOwnTractors,
  } = useGetMyOwnTractors({
    searchParam: { machineApprovalStatus: 'ALL', isPokeEnabled: false },
  });

  const setPokeStatusToEnabled = (tractor?: IMyOwnTractor) => {
    setSelectedTractor(tractor);
    setIsPokeRequestModalOpen(true);
  };

  const handlePokeRequestModalClose = () => {
    setIsPokeRequestModalOpen(false);
    changeTabIndex(PUBLISHED_TAB);
  };

  if (isGetUsersOwnTractorsLoading) {
    return <AnimateLoading />;
  }

  if (usersOwnTractors) {
    return (
      <>
        <ListContainer>
          {usersOwnTractors.map((tractor) => {
            if (!tractor || !tractor.machine) {
              return null;
            }

            return (
              <UserOwnProductDetailCardWrapper key={tractor.id}>
                <MyInfoUserOwnProductCard
                  userOwnProduct={tractor}
                  handlePokeAction={setPokeStatusToEnabled}
                  refetchList={refetchUsersOwnTractors}
                />
              </UserOwnProductDetailCardWrapper>
            );
          })}
        </ListContainer>
        <PopupConfirmModal
          isShow={isPokeRequestModalOpen}
          closeModal={() => {
            handlePokeRequestModalClose();
          }}
          title={'🔥 찔러보기 요청을 받을 수 있어요'}
          description={`다른 고객님들께서 회원님의\n${selectedTractor?.brand?.name} ${selectedTractor?.machine?.model} 트랙터를\n구경할 수 있어요.\n\n다른 고객님들에게 얼마나 많은\n관심을 받는지 확인해보세요!`}
          buttonArray={[
            {
              text: '확인',

              onClick: () => {
                handlePokeRequestModalClose();
              },
              color: 'blue',
            },
          ]}
        />
      </>
    );
  }
  return <></>;
};
